import React from 'react';
import { Modal } from 'semantic-ui-react';

/**
 * This is the administrative view for the app, which lets you do a lot of things
 * special.
 *
 * @return {*}
 * @constructor
 * @return {*} JSX for the component.
 */
const AdminView = () => {
  return (
    <div>
      <Modal.Header>ADMIN VIEW</Modal.Header>
    </div>
  );
};

export default AdminView;
